$('[name="addWrapping"]').change(function () {
	const WRAPPING_ID = 41754917929133;
	if ($('[name="addWrapping"]:checked').length) {

		$.ajax({
			'cache': false,
			'url': '/cart/add',
			'dataType': 'json',
			'type': 'POST',
			'data': {
				items: [
					{
						id: WRAPPING_ID,
						quantity: 1
			  },
			]
			},
			'error': function (XMLHttpRequest, textStatus, errorThrown) {
				//失敗した場合の処理を記述
				console.log(XMLHttpRequest, textStatus, errorThrown);
			},
			'success': function (data, dataType) {
				//成功した場合の処理を記述
				if(dataType === 'success'){
					location.reload();
				}
			},
			'complete': function (XMLHttpRequest, textStatus) {
				//完了した場合の処理を記述
			}
		});
	}
});
